// src/components/AnimeCarousel.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AnimeCarousel = ({ animeList }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
  };

  return (
    <Slider {...settings}>
      {animeList.map((anime) => (
        <div key={anime.mal_id} className="anime-slide">
          <img
            src={anime.images.jpg.image_url}
            alt={anime.title}
            style={{ width: "100%", borderRadius: "12px" }}
          />
          <p style={{ marginTop: "0.5rem", color: "#ffd700" }}>{anime.title}</p>
        </div>
      ))}
    </Slider>
  );
};

export default AnimeCarousel;
